import { Page } from '../../types'

const suspectedFraud: Page[] = [
    {
        pageType: 'question',
        title: 'Allegations of suspected fraud',
        name: 'allegations-of-suspected-fraud',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'Total number of instances',
                name: 'fraud-total-instances',
                hint: '',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'costInput',
                title: 'Estimated total value',
                name: 'fraud-estimated-total',
                hint: '',
                rules: {
                    required: false
                }
            },    
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'fraud-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default suspectedFraud
